module.exports = __webpack_public_path__ + "assets/cfc5dafd7fd28e037820129d11ed203f.svg";